export const waitlistid = "wl";
export const ddid = "dd";
export const ddresaid = "ddres";
export const ddbonus = "ddb";
export const echprj = "ept";
export const contactNumberQP = "cnum";
export const osmacc = "osmacc";

export const ftypes = {
  waitlist: waitlistid,
  dd: ddid,
  ddresa: ddresaid,
  ddbonus: ddbonus,
  echprj: echprj,
  discover: "disc", //process.env.REACT_APP_DISCOVERID,
  partner: "prtn", //process.env.REACT_APP_PARTNERID,
  project: "prj", //process.env.REACT_APP_PROJECTID,
  defaultfid: "disc", //process.env.REACT_APP_DEFAULTFORMID
};

export const idPropMap = new Map([
  //Id to property
  ["disc", process.env.REACT_APP_DISCOVERID],
  ["prtn", process.env.REACT_APP_PARTNERID],
  ["prj", process.env.REACT_APP_PROJECTID],
  ["pdc", process.env.REACT_APP_PRISECNTCTID],
  [waitlistid, process.env.REACT_APP_WAITLISTID],
  [ddid, process.env.REACT_APP_DDID],
  [ddresaid, process.env.REACT_APP_DDRESA],
  [osmacc, process.env.REACT_APP_OSMACC],
  [ddbonus, process.env.REACT_APP_DDBONUS],
  [echprj, process.env.REACT_APP_ECHPRJ],
]);

//

export const endpoints = {
  Getcontact: "/.netlify/functions/contact-get",
};
